import React from "react";
import { TextField, InputAdornment } from "@material-ui/core";
import { useStyles, Container } from "./textFieldStyles";
import { Controller } from "react-hook-form";

export interface TextFieldProps {
  control: any;
  controlingName: string;
  placeHolder: string;
  type?: string;
  rules?: any;
  minDate?: string;
  //width?: 500 | 199,
  version: TextFieldVersion;
  disabled?: boolean;
  helperText?: string;
  isMultiline?: boolean;
  maxRows?: number;
  hintText?: string;
  value?: string;
  endAdornment?: React.ReactNode;
  onKeyDown?: (
    e: React.KeyboardEvent<HTMLDivElement>,
    controlingName: string
  ) => void;
  formatValue?: (value: string, previousValue?: string) => string;
  onFocus?: (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  inputRef?: React.Ref<HTMLInputElement>;
  autoComplete?: boolean;
  // defaultValue?: string;
}

export enum TextFieldVersion {
  AUTO,
  MANUAL,
}

const TextFieldM: React.FC<TextFieldProps> = ({
  type,
  placeHolder,
  version,
  controlingName,
  control,
  disabled,
  children,
  rules,
  minDate,
  helperText,
  isMultiline,
  maxRows,
  hintText,
  value,
  endAdornment,
  onKeyDown,
  formatValue,
  onFocus,
  autoComplete= true,
  // defaultValue,
  ...props
}) => {
  const classes = useStyles(props);
  return (
    <Container>
      <Controller
        control={control}
        name={controlingName}
        rules={rules}
        render={({ field, fieldState: { error } }) => (
          // Material UI TextField already supports
          // `value` and `onChange`
          <div className={classes.wrapper}>
            <TextField
              className={classes.root}
              variant="outlined"
              InputProps={{
                className: classes.input,
                inputProps: {
                  min: minDate,
                  ...(type === "number" ? { step: "any" } : {}),
                },
                inputRef: props.inputRef,
                endAdornment: endAdornment ? (
                  <InputAdornment position="end">{endAdornment}</InputAdornment>
                ) : undefined,
              }}
              {...props}
              {...field}
              value={field.value ?? ""}
              onChange={(e) => {
                const nextValue = formatValue
                  ? formatValue(e.target.value, field.value ?? "")
                  : e.target.value;
                field.onChange(nextValue);
              }}
              onFocus={onFocus}
              autoComplete={!autoComplete?"off": undefined}
              placeholder={placeHolder}
              // value={value}
              // defaultValue={defaultValue}
              type={type}
              disabled={disabled}
              label={helperText}
              InputLabelProps={{
                shrink: true,
              }}
              multiline={isMultiline ? true : false}
              maxRows={isMultiline ? maxRows : 1}
              onKeyDown={(e) => {
                if (onKeyDown) {
                  onKeyDown(e, controlingName);
                }
              }}
            >
              {children}
            </TextField>
            <span className={classes.hintText}>{hintText && hintText}</span>
            <span className={classes.errorMessage}>
              {error && error.message}
            </span>
          </div>
        )}
      />
    </Container>
  );
};

export default TextFieldM;
